import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import {
  vendorApprovedResponse,
  vendorRequestEditsResponse,
} from "../../../actions/index.js";
import {
  ActionResponseContainer,
  ConfirmedSubmission,
} from "./actionResponseStyles.js";

import { Modal } from "../../reusableComponents/Modal/index.js";
import { SUBMISSION_RESPONSE, APPROVAL_CONFIRMATION } from "./constants.js";
import { StatusEnum } from "../../../utilities/index.js";
import ActionResponseForm from "./actionResponseForm.js";

const ActionResponse = ({ id, status }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const [vendorIsApproving, setVendorIsApproving] = useState(false);
  const [payload, setPayload] = useState({});

  const handleUserSubmit = (vendorResponse, vendorComments) => {
    setPayload({ actionRequestId: id, comment: vendorComments });
    if (vendorResponse === "request-edits") {
      dispatch(
        vendorRequestEditsResponse({
          actionRequestId: id,
          comment: vendorComments,
        })
      );
    }
    if (vendorResponse === "approved") {
      setVendorIsApproving(true);
    }
  };

  const handleConfirmedSubmit = () => {
    setVendorIsApproving(false);
    dispatch(vendorApprovedResponse(payload));
    history.push("/Vendor");
  };

  const handleCloseModal = () => setVendorIsApproving(false);
  const showApprovalModal = () => {
    return (
      <Modal
        title={"Approval Confirmation"}
        onClose={handleCloseModal}
        primaryBtn={{ label: "Continue", clickHandler: handleConfirmedSubmit }}
        secondaryBtn={{ label: "Cancel", clickHandler: handleCloseModal }}
      >
        {APPROVAL_CONFIRMATION}
      </Modal>
    );
  };

  return (
    <ActionResponseContainer>
      {vendorIsApproving && showApprovalModal()}
      {status !== StatusEnum.NEEDS_REVIEW.id ? (
        <ConfirmedSubmission>{SUBMISSION_RESPONSE}</ConfirmedSubmission>
      ) : (
        <ActionResponseForm handleUserSubmit={handleUserSubmit} />
      )}
    </ActionResponseContainer>
  );
};

ActionResponse.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  status: PropTypes.number,
};

export default ActionResponse;
